<div class="carousel">
  <div class="carousel-sliders">
    <div class="carousel-slider" [class.disabled]="slideIndex === 0" (click)="scrollToPreviousSlide()">
      <span class="icon-left-arrow"></span>
    </div>
    <div class="carousel-slider" [class.disabled]="slideIndex === maxSlideIndex - 1" (click)="scrollToNextSlide()">
      <span class="icon-right-arrow"></span>
    </div>
  </div>

  <div class="carousel-inner">
    <div class="slide" *ngFor="let slide of carousel.slides; let index = index">
      <div class="image-container">
        <img [src]="slide.pictureURL" [attr.alt]="'alt/an_image' | translate" />
      </div>
      <div class="slide-description">
        <span class="text">{{ slide.text }}</span>
        <span class="description">{{ slide.description }}</span>
      </div>

      <div class="alc-buttons">
        <button
          class="alc-button"
          [class.alc-message-url-button]="button.url"
          [class.alc-buttons-already-clicked]="button.buttonAlreadyClicked"
          *ngFor="let button of slide.buttons"
          [attr.aria-label]="button.text"
          (click)="onButtonClicked(button)">
          <span>{{ button.text }}</span>
          <ng-container *ngIf="button.url">
            <span class="icon-url-button"></span>
          </ng-container>
        </button>
      </div>
    </div>
  </div>

  <div class="carousel-stepper">
    <div
      class="step"
      [class.selected]="slideIndex === index"
      (click)="scrollToSlide(index, true)"
      *ngFor="let step of carousel.slides; index as index"></div>
  </div>
</div>

<!-- 
<button class="carousel-time"></button>
 -->
